import React from 'react';
import I18n from 'i18n-js';

import { formatAmountCents, isEmptyMoneyResponse, IMoneyConfig } from '../money';
import PriceDisplay from './price_display';

interface IMoney {
  amountCents?: number;
  currency?: string;
}

interface IProps {
  moneyLow: IMoney;
  moneyHigh: IMoney;
  showFree?: boolean;
  auction?: boolean;
  displayConfig?: IMoneyConfig;
}

PriceDisplayRange.defaultProps = {
  showFree: false,
  auction: false,
  displayConfig: {},
};

export default function PriceDisplayRange(props: IProps) {
  const { moneyLow, moneyHigh, showFree, auction, displayConfig } = props;
  if (isEmptyMoneyResponse(moneyLow) || isEmptyMoneyResponse(moneyHigh)) {
    return null;
  }

  const lowEqualsHigh =
    moneyLow.amountCents === moneyHigh.amountCents &&
    moneyLow.currency === moneyHigh.currency;

  if (lowEqualsHigh) {
    return (
      <PriceDisplay
        amountCents={moneyLow.amountCents}
        currency={moneyLow.currency}
        display={formatAmountCents(moneyLow, displayConfig)}
      />
    );
  }

  return (
    <div className="price-display-range">
      <PriceDisplay
        amountCents={moneyLow.amountCents}
        currency={moneyLow.currency}
        display={formatAmountCents(moneyLow, displayConfig)}
        showFree={showFree}
        auction={auction}
      />
      <span>{I18n.t('commons.priceDisplayRangeSeparator')}</span>
      <PriceDisplay
        amountCents={moneyHigh.amountCents}
        currency={moneyHigh.currency}
        display={formatAmountCents(moneyHigh, displayConfig)}
        showFree={showFree}
        auction={auction}
      />
    </div>
  );
}
